import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
   formControl: {
	   marginLeft: theme.spacing(5),
	   marginRight: theme.spacing(5),
	   marginBottom: theme.spacing(5)
	},
   menuItem: {
      "&:hover": {
         backgroundColor: theme.palette.primary.light
      }
   },
   select: {
		minWidth: "10rem"
	}
}));

export default function FilterSelect({ label, value, options, onChange }) {
   const classes = useStyles();
   const [selectedValue, setSelectedValue] = useState(value);

   useEffect(() => {
      setSelectedValue(value);
   }, [value]);

   let handleClearFilter = (itemVal) => itemVal === "all" ? undefined : itemVal;

   let onChangeSelect = function(event) {
      setSelectedValue(event.target.value);
      onChange(handleClearFilter(event.target.value));
   }
   
   return (
      <FormControl className={classes.formControl}>
         <InputLabel>{label}</InputLabel>
         <Select
            className={classes.select}
            value={selectedValue}
            onChange={onChangeSelect}
         >
            <MenuItem value={"all"} className={classes.menuItem}><em>All</em></MenuItem>
            {options.map((option, index) => (
               <MenuItem key={index} value={option.value} className={classes.menuItem}>{option.label}</MenuItem>
            ))}
         </Select>
      </FormControl>
   );
}

FilterSelect.propTypes = {
   label: PropTypes.string,
   value: PropTypes.string,
   options: PropTypes.array,
   onChange: PropTypes.func,
   noneValue: PropTypes.bool
};
